import React from 'react';
import PropTypes from 'prop-types';
import {Icon} from '@/components/atoms';
import useMediaThumbnailDownload from './hooks/useMediaThumbnailDownload';

const MediaThumbnail = ({url, alt, onPreview, type, downloadUrl}) => {
  const {downloadProgress, handleDownload} = useMediaThumbnailDownload({
    downloadUrl,
    type
  });

  return (
    <div className='relative inline-block h-[100px] w-[156px] overflow-hidden rounded-lg border border-dashed border-gray-600 bg-gray-800 align-top'>
      {url ? (
        <>
          <img
            src={url}
            alt={alt}
            className='block h-[100px] w-[156px] rounded-lg object-cover'
            data-testid={`thumbnail-${alt}`}
          />
          {/* Download progress overlay for video */}
          {type === 'video' && downloadProgress !== null && (
            <div className='absolute inset-0 z-20 flex items-center justify-center rounded-lg bg-black bg-opacity-60'>
              <div className='w-3/4'>
                <div className='h-2 overflow-hidden rounded-full bg-gray-700'>
                  <div
                    className='h-2 rounded-full bg-blue-400 transition-all duration-200'
                    style={{width: `${downloadProgress}%`}}
                  />
                </div>
                <div className='mt-1 text-center text-xs text-white'>
                  {downloadProgress}%
                </div>
              </div>
            </div>
          )}
          <button
            type='button'
            onClick={type === 'video' ? handleDownload : onPreview}
            className='absolute bottom-1 right-1 z-10 flex h-8 min-h-[32px] w-8 min-w-[32px] items-center justify-center rounded border border-[#4E4E4E] bg-[#1D1D1D] p-1'
            data-testid={`thumbnail-preview-btn-${alt}`}
            disabled={type === 'video' && downloadProgress !== null}>
            <Icon
              icon={type === 'video' ? 'download' : 'open_in_full'}
              size='small'
              isDark
              className='text-[#7DB3FC]'
            />
          </button>
        </>
      ) : (
        <div className='flex h-full w-full items-center justify-center'>
          <p className='text-xs text-gray-500'>No Image</p>
        </div>
      )}
    </div>
  );
};

MediaThumbnail.propTypes = {
  url: PropTypes.string,
  alt: PropTypes.string,
  onPreview: PropTypes.func,
  type: PropTypes.oneOf(['image', 'video']),
  downloadUrl: PropTypes.string
};

export default MediaThumbnail;
